export default "__VITE_ASSET__1vbreHTM__"